module.exports = __webpack_public_path__ + "img/box_sm.c674f6c0.png";